import {
  IS_BENE_SCHEMA_ENABLED,
  RESET_NEW_BENE_FLOW_STATE,
  SET_BENE_REVAMP_FORM_VALUES,
  SET_PAYOUT_API_RESPONSE,
  SET_SCHEMA_API_RESPONSE,
  SET_NON_SCHEMA_COUNTRIES_API_RESPONSE,
  SET_CURRENT_BENE,
  SET_RECEIVING_METHOD_BANK_ACCOUNT_COUNTRY_VALUES,
  TOGGLE_IS_EDIT_BENE_FLOW,
  TOGGLE_REDIRECTED_FROM_SEND_MONEY,
  SET_SELECTED_COUNTRY_MOBILE_CODE,
  SET_PAYOUT_LABEL,
  RESET_FORM_VALUES_STATE,
  SET_IS_SELF_BENE,
  SET_POPULAR_COUNTRIES,
  SET_ADDRESS_CONFIG,
  SET_BENE_BANK_NAME,
  SET_UNFILTERED_CURRENT_BENE,
  SET_CURRENT_BENE_ID,
  SET_CURRENT_FORM_BENE_ADDRESS,
  TOGGLE_SHOULD_PREFILL_BENE_ADDRESS
} from '@Redux/action-contants';
import { getBeneficiaryByID, getBeneficiaryByIDBeneServiceGeneric, makeApiCall } from '../common';
import { API_URL } from '@Utils/config';
import { handleError } from '../common-message';
import { ReceivingMethodBankAccountCountryObjectType } from '../../../screens/beneficiary-flow/types/redux-types';
import { IStore } from '../../../store.type';
import { ReceivingMethodFormValueType } from '../../../screens/beneficiary-flow/pages/receiving-method/utils/types/types';
import { checkBeneSchemaEnabled } from '../../../screens/beneficiary-flow/pages/receiving-method/utils/methods';
import { initializeForm, setStreetforAddress } from '@Utils/library';
import { PAYEE_DETAILS_FORM } from '../../../screens/beneficiary-flow/constants/commons';

export const setBeneRevampFormValues = (formValues?: ReceivingMethodFormValueType) => ({
  type: SET_BENE_REVAMP_FORM_VALUES,
  data: formValues
});
export const setPayoutApiValues = (values: any) => ({
  type: SET_PAYOUT_API_RESPONSE,
  data: values
});
export const setSchemaApiValues = (values: any) => ({
  type: SET_SCHEMA_API_RESPONSE,
  data: values
});
export const setNonSchemaCountriesApiValues = (values: any) => ({
  type: SET_NON_SCHEMA_COUNTRIES_API_RESPONSE,
  data: values
});

export const setIsBeneSchemaEnabled = (value: boolean) => ({
  type: IS_BENE_SCHEMA_ENABLED,
  data: value
});

export const setIsSelfBene = (data: boolean) => ({
  type: SET_IS_SELF_BENE,
  data
});

export const setReceivingMethodBankAccountCountryValues = (
  values: ReceivingMethodBankAccountCountryObjectType[]
) => {
  return {
    type: SET_RECEIVING_METHOD_BANK_ACCOUNT_COUNTRY_VALUES,
    data: values
  };
};

export const navigateHistory = ({
  type,
  screen
}: {
  type: 'PUSH_NAVIGATION_HISTORY' | 'POP_NAVIGATION_HISTORY' | 'CLEAR_NAVIGATION_HISTORY';
  screen?: string;
}) => ({
  type,
  data: screen
});

export const getBeneficiaryCountries = (params: Record<string, any>) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/beneficiary/countries/dropdown`,
        params,
        withCredentials: true
      });

      return response.data.data;
    } catch (exception) {
      dispatch(handleError(exception));
    }
  };
};

export const toggleRedirectedFromSendMoneyAction = (flag: boolean) => {
  return {
    type: TOGGLE_REDIRECTED_FROM_SEND_MONEY,
    data: flag
  };
};

export const toggleIsEditBeneFlowAction = (flag: boolean) => {
  return {
    type: TOGGLE_IS_EDIT_BENE_FLOW,
    data: flag
  };
};

export const setCurrentBeneDataAction = (data: Record<string, any>) => {
  return {
    type: SET_CURRENT_BENE,
    data
  };
};

export const setUnfilteredCurrentBeneDataAction = (data: Record<string, any>) => {
  return {
    type: SET_UNFILTERED_CURRENT_BENE,
    data
  };
};

export const setSelectedCountryMobileCodeAction = (data: string) => {
  return {
    type: SET_SELECTED_COUNTRY_MOBILE_CODE,
    data
  };
};
export const setSelectedLabelAction = (data: string) => {
  return {
    type: SET_PAYOUT_LABEL,
    data
  };
};
export const setBeneBankNameAction = (data: string | null) => {
  return {
    type: SET_BENE_BANK_NAME,
    data
  };
};
export const setPopularCountriesAction = (data: ReceivingMethodBankAccountCountryObjectType[]) => {
  return {
    type: SET_POPULAR_COUNTRIES,
    data
  };
};

export const resetFormValueStateAction = () => {
  return {
    type: RESET_FORM_VALUES_STATE
  };
};
export const resetNewBeneFlowStateAction = () => ({ type: RESET_NEW_BENE_FLOW_STATE });

export const setAddressConfigAction = (data: Record<string, any>) => {
  return {
    type: SET_ADDRESS_CONFIG,
    data
  };
};

export const setCurrentBeneIdAction = (data: number) => {
  return {
    type: SET_CURRENT_BENE_ID,
    data
  };
};

export const setCurrentFormBeneAddressAction = (data: Record<string, any>) => {
  return {
    type: SET_CURRENT_FORM_BENE_ADDRESS,
    data
  };
};

export const toggleShouldPrefillBeneAddressAction = (data: boolean) => {
  return {
    type: TOGGLE_SHOULD_PREFILL_BENE_ADDRESS,
    data
  };
};
export const getBeneficiary = () => {
  return async (dispatch: (data: any) => void, getState: () => IStore): Promise<any> => {
    try {
      const {
        bank_account_country_code,
        beneficiary_id,
        currency_code: currency_code_usr
      } = window.history.state?.usr || {};
      let currency_code = currency_code_usr;

      const store = getState();

      const isBeneServiceApplicable = checkBeneSchemaEnabled(
        store.rootReducer.userStatusReducer.account_type,
        bank_account_country_code,
        currency_code
      );

      const getBene = isBeneServiceApplicable
        ? getBeneficiaryByIDBeneServiceGeneric
        : getBeneficiaryByID;

      const beneficiaryData: any = await dispatch(getBene(beneficiary_id));
      const beneficiaryDetails = beneficiaryData.data.data;
      const countryCode =
        beneficiaryDetails.country_code || beneficiaryDetails.beneficiary_country_code;
      const country_code =
        beneficiaryDetails.country_code || beneficiaryDetails.beneficiary_country_code;
      currency_code = beneficiaryDetails.currency_code || beneficiaryDetails.destination_currency;
      const bank_account_country =
        beneficiaryDetails.bank_account_country || beneficiaryDetails.destination_country;
      const account_type =
        beneficiaryDetails.account_type || beneficiaryDetails.beneficiary_account_type;
      if (isBeneServiceApplicable) {
        beneficiaryDetails['country_code'] = country_code;
        beneficiaryDetails['currency_code'] = currency_code;
        beneficiaryDetails['bank_account_country'] = bank_account_country;
        beneficiaryDetails['account_type'] = account_type;
      }
      //Capture only needed values for Edit form.
      const obj = initializeForm(PAYEE_DETAILS_FORM, {
        ...beneficiaryDetails,
        ...(() =>
          setStreetforAddress(
            countryCode,
            beneficiaryDetails.street_name,
            beneficiaryDetails.street_type
          ))()
      });
      const additionalInfo = (obj.additional_info && { ...obj.additional_info }) || {};
      delete obj.additional_info;

      dispatch(setCurrentBeneDataAction({ ...obj, ...additionalInfo }));
      dispatch(setUnfilteredCurrentBeneDataAction(beneficiaryDetails));
    } catch (e) {
      dispatch(handleError(e));
    }
  };
};
